import type { EstimateLine } from '@fruitways/shared';
import { dayTotals, messages } from '@fruitways/shared';
import { cell } from '@/lib/format';

/** Variety by day table used on review and detail. Zero cells read as a dash. */
export function EstimateTable({ lines }: { lines: ReadonlyArray<EstimateLine> }) {
  const t = messages.review.table;
  const perDay = dayTotals(lines);
  const grand = perDay.reduce((a, b) => a + b, 0);
  return (
    <div className="fw-rows fw-tnum">
      <div className="fw-table__head">
        <span style={{ textAlign: 'left' }}>{t.variety}</span>
        {t.days.map((d, i) => (
          <span key={i}>{d}</span>
        ))}
        <span>{t.total}</span>
      </div>
      {lines.map((l) => (
        <div key={l.varietyCode} className="fw-table__row">
          <span className="fw-table__code">{l.varietyCode}</span>
          {l.bins.map((n, i) => (
            <span key={i} className={n > 0 ? undefined : 'fw-table__zero'}>
              {cell(n)}
            </span>
          ))}
          <span className="fw-table__total">{l.bins.reduce((a, b) => a + b, 0)}</span>
        </div>
      ))}
      {/* A role, because screen readers ignore aria-label on a plain div. */}
      <div
        className="fw-table__row fw-table__row--totals"
        role="group"
        aria-label={t.dayTotalRowLabel}
      >
        <span className="fw-table__code">{t.dayTotal}</span>
        {perDay.map((n, i) => (
          <span key={i} className={n > 0 ? undefined : 'fw-table__zero'}>
            {cell(n)}
          </span>
        ))}
        <span className="fw-table__total">{grand}</span>
      </div>
    </div>
  );
}
